module.exports = __webpack_public_path__ + "img/online_trainings.70756a3d.png";